import React, { Component } from 'react';
import { TableLayout } from '../Menu/Stock/containers/Layout';
import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';

import NewInstallater from '../Menu/module/paygoNewInstallater.jsx';
import TechStats from './Techs/TechStats';
import TechOptions from './Techs/InstallerOptions';

import { isEmpty } from "lodash";
import { Table, TableBody, TableRow, TableCell, Grid, Button, TableHead, IconButton } from '@material-ui/core';
import { FormatListBulletedRounded, BarChartRounded, MoreVertRounded } from '@material-ui/icons';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';

class InstallersList extends Component {
    state = { 
        new: false,
        suivi: false,
        list: [],
        details: false,
        current: "",
        openOptions: false,
     }
    componentDidMount = async () => {
        const { INSTALLERS } = this.props;
        if( isEmpty(INSTALLERS) ){
            await this.props.fetchInstallers()
        }
        this.filterList()
    }
    fetchDetails = async (installer) => {
        if(!installer.other){
            await this.props.updateInstaller(installer)
        }
        this.setState({
            details:true,
            current:installer.id
        })
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.INSTALLERS) ){
                list = Object.keys(this.props.INSTALLERS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    render() {
        const { INSTALLERS } = this.props;
        const { openOptions,details, current} = this.state;
        return (
            <PageAdmin title="Techniciens">
                {this.state.new &&
                    <NewInstallater popupState={"overlay"} onCloseOverlay={()=>
                        this.setState({ new: false })}/>
                }
                {( details && current && !openOptions) &&
                    <Dialog 
                        title="Details"
                        block={details}
                        title={"Details"}
                        close={()=> this.setState({details:false, current:""}) }
                    >
                        <TableLayout>
                            <TableBody className="text-left">
                                {INSTALLERS[current].other ? (
                                    Object.keys(INSTALLERS[current].other).map( key => (
                                        <TableRow key={key} hover>
                                            <TableCell>{key}</TableCell>
                                            <TableCell>{ key.startsWith("Photo") ? (
                                                    <img src={INSTALLERS[current].other[key]} alt={key} />
                                                ) : (
                                                    Array.isArray(INSTALLERS[current].other[key]) ? 
                                                    INSTALLERS[current].other[key].join(' - ') :
                                                    INSTALLERS[current].other[key]                                                         
                                                )
                                            }
                                            </TableCell>
                                        </TableRow>
                                    )) 

                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={2}>Pas d'informations</TableCell>
                                    </TableRow>
                                ) }
                            </TableBody>
                            
                        </TableLayout>
                    </Dialog>
                }
                {/* <h3>Installateurs</h3> */}
                {/* <Grid container spacing={2}>
                    <Grid item sm={3} >
                        <Button 
                            variant="contained"
                            color="secondary" 
                            onClick={()=>
                                this.setState({ new: true })
                            }>Nouveau</Button>
                    </Grid>
                    <Grid item sm={9} >
                        <SearchBar list={ INSTALLERS } filterList={this.filterList}/>
                    </Grid>
                </Grid> */}
                <SearchBarAction  list={ INSTALLERS } filterList={this.filterList} action={() => this.setState({ new: true })} />
  
                {( openOptions && current ) &&
                
                <Dialog 
                    title="Options"
                    block={openOptions}
                    close={()=> this.setState({openOptions:false, current:""}) }
                    noScroll
                >
                    <TechOptions  userID={this.state.current} close={()=> { this.props.fetchAgents();this.setState({openOptions:false, current:""})}}/> 
                </Dialog>
                }
                {this.state.suivi ? (
                    <div>
                        <div className="text-right">
                            <IconButton 
                                className="btn btn-info btn-icon waves-float" 
                                title="Liste des Techniciens"
                                onClick={()=>
                                    this.setState({ suivi: false })
                                }
                            >
                                {/* <i className="zmdi zmdi-format-list-bulleted"></i> */}
                                <FormatListBulletedRounded />
                            </IconButton>                        
                        </div>
                        <TechStats {...this.state} {...this.props}/>
                    </div>
                ) : (
                    <div>
                        <div className="text-right">
                            <IconButton 
                                className="btn btn-info btn-icon waves-float" 
                                title="Suivi Performance"
                                onClick={()=>
                                    this.setState({ suivi: true })
                                }
                            >
                                {/* <i className="zmdi zmdi-chart"></i> */}
                                <BarChartRounded />
                            </IconButton>                        
                        </div>
                        <TableLayout >
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th">Name</TableCell>
                                    <TableCell component="th">Phone</TableCell>
                                    <TableCell component="th">Email</TableCell>
                                    <TableCell component="th">Entreprise</TableCell>
                                    <TableCell component="th">Option</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {INSTALLERS && this.state.list.map( ID => {
                                    let installer = INSTALLERS[ID]
                                    return(
                                        <TableRow key={installer.id} onClick={()=> this.fetchDetails(installer) }>
                                            <TableCell>{installer.name}</TableCell>
                                            <TableCell>{
                                                (Array.isArray(installer.phone) ? 
                                                installer.phone.join("\r\n") : 
                                                installer.phone) 
                                                }</TableCell>
                                            <TableCell>{installer.email}</TableCell>
                                            <TableCell>{installer.company}</TableCell>
                                            <TableCell>
                                                <IconButton 
                                                    color="secondary"
                                                    onClick={()=> this.setState({openOptions: true, current: ID}) }>
                                                    {/* <i className="zmdi zmdi-more-vert"></i> */}
                                                    <MoreVertRounded />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                } )
                            }

                                
                            </TableBody>
                        </TableLayout>
                    </div>
                )}
            </PageAdmin>
        );
    }
}


export default InstallersList